/** Utilidades de RUT chileno: limpieza, formato y validación módulo 11. */

/** Deja solo dígitos y K, en mayúscula (sin puntos ni guion). */
export function cleanRut(rut: string): string {
  return rut.replace(/[^0-9kK]/g, "").toUpperCase();
}

/** Dígito verificador módulo 11, algoritmo estándar chileno. */
export function calcularDv(cuerpo: string): string {
  let suma = 0;
  let multiplicador = 2;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += Number(cuerpo[i]) * multiplicador;
    multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
  }
  const resto = 11 - (suma % 11);
  if (resto === 11) return "0";
  if (resto === 10) return "K";
  return String(resto);
}

export function esRutValido(rut: string): boolean {
  const limpio = cleanRut(rut);
  if (!/^\d{7,8}[0-9K]$/.test(limpio)) return false;
  return calcularDv(limpio.slice(0, -1)) === limpio.slice(-1);
}

/**
 * Formatea progresivamente mientras se escribe: 761234567 -> 76.123.456-7.
 * Con menos de 2 caracteres se devuelve tal cual para no estorbar al tipear.
 */
export function formatRut(rut: string): string {
  const limpio = cleanRut(rut).slice(0, 9);
  if (limpio.length <= 1) return limpio;
  const cuerpo = limpio.slice(0, -1);
  const dv = limpio.slice(-1);
  const conPuntos = cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${conPuntos}-${dv}`;
}
